<template>
  <div class="topbar_box">
    <div class="topbar">
      <van-icon name="arrow-left" @click="$router.back()" />
      <div class="item_title">{{ title }}</div>
    </div>
  </div>
</template>
<script>
import { Icon } from 'vant'
export default {
  components: {
    [Icon.name]: Icon
  },
  props: {
    title: {
      type: String,
      default: '听遍陕西'
    }
  }
}
</script>
<style lang="less" scoped>
.topbar_box {
  height: 1.1733rem;
}
.topbar {
  width: 100%;
  max-width: 750px;
  height: 1.1733rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  // border-bottom: 1px solid #ebedf0;
}
.item_title {
  font-size: 0.4267rem;
  color: #222;
  letter-spacing: 0.0267rem;
}
/deep/.van-icon {
  position: absolute;
  left: 0.2667rem;
  font-size: 0.5333rem;
}
</style>
